import { render } from "./MainNavigation.vue?vue&type=template&id=6aaf7b1a&scoped=true"
import script from "./MainNavigation.vue?vue&type=script&lang=js"
export * from "./MainNavigation.vue?vue&type=script&lang=js"

import "./MainNavigation.vue?vue&type=style&index=0&id=6aaf7b1a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6aaf7b1a"

export default script